(() => {
  const init = (root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('[data-promo-card]')];
    const grid = root.querySelector('[data-promo-grid]');
    const brand = root.querySelector('[data-promo-brand]');
    const search = root.querySelector('[data-promo-search]');
    const sort = root.querySelector('[data-promo-sort]');
    const buttons = [...root.querySelectorAll('[data-promo-type]')];
    const more = root.querySelector('[data-promo-more]');
    const reset = root.querySelector('[data-promo-reset]');
    const size = Number(root.dataset.pageSize) || 9;
    const labels = new Map(cards.map(card => [card.dataset.brand, card.dataset.brandLabel]));
    [...labels].sort((a,b) => a[1].localeCompare(b[1])).forEach(([value,label]) => brand.add(new Option(label, value)));
    let type = 'all', limit = size;
    const params = new URLSearchParams(location.search);
    if (['bike','atv','sxs'].includes(params.get('vehicle'))) type = params.get('vehicle');
    const hashBrand = location.hash.replace('#promos-', '');
    if (labels.has(params.get('brand'))) brand.value = params.get('brand');
    else if (labels.has(hashBrand)) brand.value = hashBrand;
    const update = () => {
      const query = search.value.trim().toLowerCase();
      const matches = cards.filter(card => (type === 'all' || card.dataset.type === type) && (brand.value === 'all' || card.dataset.brand === brand.value) && `${card.dataset.model} ${card.dataset.brandLabel}`.toLowerCase().includes(query));
      matches.sort((a,b) => sort.value === 'featured' ? Number(b.dataset.rebate) - Number(a.dataset.rebate) || Number(a.dataset.rate) - Number(b.dataset.rate) || Number(b.dataset.year) - Number(a.dataset.year) || a.dataset.model.localeCompare(b.dataset.model) : sort.value === 'brand' ? a.dataset.brand.localeCompare(b.dataset.brand) || a.dataset.model.localeCompare(b.dataset.model) : sort.value === 'model' ? a.dataset.model.localeCompare(b.dataset.model) : Number(b.dataset.year) - Number(a.dataset.year) || a.dataset.brand.localeCompare(b.dataset.brand) || a.dataset.model.localeCompare(b.dataset.model));
      cards.forEach(card => { card.hidden = true; });
      matches.forEach((card,index) => { grid.append(card); card.hidden = index >= limit; });
      buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.promoType === type)));
      more.hidden = matches.length <= limit;
      root.querySelector('[data-promo-empty]').hidden = matches.length > 0;
      reset.hidden = type === 'all' && brand.value === 'all' && !query;
      root.querySelector('[data-promo-count]').textContent = root.dataset.countTemplate.replace('[shown]', Math.min(limit,matches.length)).replace('[total]',matches.length);
      const url = new URL(location.href);
      type === 'all' ? url.searchParams.delete('vehicle') : url.searchParams.set('vehicle',type);
      brand.value === 'all' ? url.searchParams.delete('brand') : url.searchParams.set('brand',brand.value);
      if (url.hash.startsWith('#promos-')) url.hash = '';
      history.replaceState(null,'',url);
    };
    buttons.forEach(button => button.addEventListener('click',() => {type = button.dataset.promoType; limit = size; update();}));
    [brand,sort].forEach(control => control.addEventListener('change',() => {limit = size; update();}));
    search.addEventListener('input',() => {limit = size; update();});
    more.addEventListener('click',() => {limit += size; update();});
    reset.addEventListener('click',() => {type = 'all'; brand.value = 'all'; search.value = ''; limit = size; update();});
    root.querySelector('[data-promo-controls]').hidden = false;
    update();
  };
  document.querySelectorAll('[data-promo-browser]').forEach(init);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-promo-browser]').forEach(init));
})();
